// extracted by mini-css-extract-plugin
export default {"error":"FormError__error___1_idQ"};